import { FunctionComponent } from 'react';
import styles from './LoginActivateList.module.scss';
import { Icons } from '../../icons';

export const LoginActivateList: FunctionComponent = () => {
	const items = [
		<span>Self-Defense Liability Insurance<sup>1</sup></span>,
		<>24/7 Critical Response Team</>,
		<>Exclusive Perks &amp; Discounts</>,
		<>Livesaving Education &amp; Training</>
	];

	return (
		<>
			<ul className={styles.benefitsList}>
				{items.map((item, index) => (
					<li key={index}>{Icons.CheckHardEdges} {item}</li>
				))}
			</ul>
			<p className={styles.lead} >
				Enter your email to begin:
			</p >
		</>
	);
};
